import React, { useEffect, useState } from 'react'
import { Button, Card, ListGroup, Spinner, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import AddressForm from './AddressForm'
import { fetchAddresses, addAddress as addAddressThunk, updateAddress as updateAddressThunk, deleteAddress as deleteAddressThunk, setPreferredAddress as setPreferredAddressThunk } from '../slices/userSlice'

const AddressManager = () => {
  const dispatch = useDispatch()
  const { userInfo, shippingAddresses, preferredShippingAddressId, addressesLoading, addressesError } = useSelector(s => s.user)

  const [mode, setMode] = useState('list') // 'list' | 'add' | 'edit'
  const [editingId, setEditingId] = useState(null)
  const [formValue, setFormValue] = useState({ address1: '', address2: '', city: '', state: '', postalCode: '', country: '' })

  useEffect(() => {
    if (userInfo && !userInfo.isGuest) dispatch(fetchAddresses())
  }, [dispatch, userInfo])

  const startAdd = () => { setMode('add'); setEditingId(null); setFormValue({ address1: '', address2: '', city: '', state: '', postalCode: '', country: '' }) }
  const startEdit = (addr) => { setMode('edit'); setEditingId(addr._id); setFormValue({ address1: addr.address1||'', address2: addr.address2||'', city: addr.city||'', state: addr.state||'', postalCode: addr.postalCode||'', country: addr.country||'' }) }
  const cancelForm = () => { setMode('list'); setEditingId(null) }

  const addAddress = async () => { await dispatch(addAddressThunk(formValue)); setMode('list') }
  const saveEdit = async () => { await dispatch(updateAddressThunk({ id: editingId, address: formValue })); setMode('list'); setEditingId(null) }
  const deleteAddress = async (id) => { await dispatch(deleteAddressThunk(id)) }
  const setPreferred = async (id) => { await dispatch(setPreferredAddressThunk(id)) }

  if (userInfo?.isGuest) {
    return <div className='text-muted'>Address management is unavailable for guest accounts.</div>
  }

  if (addressesLoading) {
    return <div className='d-flex align-items-center gap-2'><Spinner size='sm' animation='border' /> <span>Loading addresses…</span></div>
  }

  if (mode === 'add') {
    return (
      <Card>
        <Card.Header>Add Address</Card.Header>
        <Card.Body>
          <AddressForm value={formValue} onChange={setFormValue} onSubmit={addAddress} onCancel={cancelForm} submitLabel='Add' />
        </Card.Body>
      </Card>
    )
  }
  if (mode === 'edit') {
    return (
      <Card>
        <Card.Header>Edit Address</Card.Header>
        <Card.Body>
          <AddressForm value={formValue} onChange={setFormValue} onSubmit={saveEdit} onCancel={cancelForm} submitLabel='Save' />
        </Card.Body>
      </Card>
    )
  }

  return (
    <Card>
      <Card.Header className='d-flex justify-content-between align-items-center'>
        <span>Saved Addresses</span>
        <Button size='sm' onClick={startAdd} disabled={(shippingAddresses||[]).length >= 6}>Add Address</Button>
      </Card.Header>
      <ListGroup variant='flush'>
        {(shippingAddresses||[]).length === 0 && (
          <ListGroup.Item className='text-muted'>No saved addresses yet.</ListGroup.Item>
        )}
        {(shippingAddresses||[]).map(addr => (
          <ListGroup.Item key={addr._id}>
            <div className='d-flex justify-content-between align-items-start gap-3'>
              <div>
                <div>{addr.address1}</div>
                {addr.address2 && <div>{addr.address2}</div>}
                <div>{addr.city}, {addr.state} {addr.postalCode}</div>
                <div>{addr.country}</div>
              </div>
              <div className='text-end'>
                <Form.Check
                  type='radio'
                  name='preferredAddress'
                  id={`pref-${addr._id}`}
                  label='Preferred'
                  checked={String(preferredShippingAddressId||'') === String(addr._id)}
                  onChange={()=> setPreferred(addr._id)}
                />
                <div className='mt-2 d-flex gap-2 justify-content-end'>
                  <Button size='sm' variant='outline-secondary' onClick={()=> startEdit(addr)}>Edit</Button>
                  <Button size='sm' variant='outline-danger' onClick={()=> deleteAddress(addr._id)}>Delete</Button>
                </div>
              </div>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
      {addressesError && <div className='text-danger p-2'>{addressesError}</div>}
    </Card>
  )
}

export default AddressManager
